module.exports = __webpack_public_path__ + "static/media/download-file.4bb09f95.svg";